import axiosInstance from "../../axiosInstance";

// const base = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
// const BASE_URL = `${base}/plans`;
// const NOTI_URL = `${base}/notifications`;

const BASE_URL = "/hrm/plans";
const NOTI_URL = "/hrm/plans/notifications";

const handleError = (fnName, error) => {
  console.error(`Lỗi ${fnName}:`, error?.response || error);
  throw error;
};

// ========== PLANS ==========
export const getPlans = async (params = {}) => {
  try {
    const { keyword, pageSize, ...rest } = params;
    const query = {
      ...rest,
      search: keyword ?? rest.search ?? "",
      limit: pageSize ?? rest.limit ?? 50,
    };
    delete query.keyword;
    delete query.pageSize;
    const res = await axiosInstance.get(BASE_URL, { params: query });
    return res.data;
  } catch (error) {
    handleError("getPlans", error);
  }
};

export const getIncompletePlans = async (params = {}) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/incomplete`, { params });
    return res.data;
  } catch (error) {
    handleError("getIncompletePlans", error);
  }
};

export const getPlanById = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    handleError("getPlanById", error);
  }
};

export const getDepartments = async (branchId) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/departments`, {
      params: { branch_id: branchId }
    });
    return res.data;
  } catch (error) {
    handleError("getDepartments", error);
  }
};

// === Plan status ===
export const updatePlanStatus = async (id, status) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}/status`, { status });
    return res.data;
  } catch (error) {
    handleError("updatePlanStatus", error);
  }
};

// (tùy chọn) helper lấy theo 1 status
export const getPlansByStatus = async (status, extraParams = {}) => {
  return getPlans({ status, ...extraParams });
};


export const createPlan = async (data) => {
  try {
    const res = await axiosInstance.post(BASE_URL, data);
    return res.data;
  } catch (error) {
    handleError("createPlan", error);
  }
};

export const updatePlan = async (id, data) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return res.data;
  } catch (error) {
    handleError("updatePlan", error);
  }
};

export const deletePlan = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    handleError("deletePlan", error);
  }
};

// ========== APPROVAL ==========
export const getPlanApprovals = async (planId) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${planId}/approvals`);
    return res.data;
  } catch (error) {
    handleError("getPlanApprovals", error);
  }
};

export const approvePlan = async (planId, data = {}) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/${planId}/approve`, data);
    return res.data;
  } catch (error) {
    handleError("approvePlan", error);
  }
};

export const rejectPlan = async (planId, data = {}) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/${planId}/reject`, data);
    return res.data;
  } catch (error) {
    handleError("rejectPlan", error);
  }
};

// ========== COMMENTS ==========
export const getPlanComments = async (planId) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${planId}/comments`);
    return res.data;
  } catch (error) {
    handleError("getPlanComments", error);
  }
};

export const addPlanComment = async (planId, data) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/${planId}/comments`, data);
    return res.data;
  } catch (error) {
    handleError("addPlanComment", error);
  }
};

// ========== NOTIFICATIONS ==========
export const getNotifications = async (employeeId) => {
  try {
    const res = await axiosInstance.get(NOTI_URL, { params: { employee_id: employeeId } });
    return res.data;
  } catch (error) {
    handleError("getNotifications", error);
  }
};

export const markNotificationRead = async (id) => {
  try {
    const res = await axiosInstance.put(`${NOTI_URL}/${id}/read`);
    return res.data;
  } catch (error) {
    handleError("markNotificationRead", error);
  }
};

export const createNotification = async (data) => {
  try {
    const res = await axiosInstance.post(NOTI_URL, data);
    return res.data;
  } catch (error) {
    handleError("createNotification", error);
  }
};
